import React, { createContext, useContext, useEffect, useState, useCallback } from 'react'
import { apiMisTours, apiCompletarTour } from 'services/TourService'

const TourContext = createContext({
    toursVistos: [],
    listo: false,
    hasSeenTour: () => true,
    markTourSeen: () => {},
})

export const TourProvider = ({ children }) => {
    const [toursVistos, setToursVistos] = useState([])
    const [listo, setListo] = useState(false)

    useEffect(() => {
        let activo = true
        apiMisTours().then((resp) => {
            if (activo) {
                setToursVistos(resp?.data?.toursVistos || [])
                setListo(true)
            }
        }).catch(() => {
            if (activo) setListo(true)
        })
        return () => { activo = false }
    }, [])

    const hasSeenTour = useCallback((tour) => toursVistos.includes(tour), [toursVistos])

    const markTourSeen = useCallback((tour) => {
        setToursVistos((prev) => (prev.includes(tour) ? prev : [...prev, tour]))
        apiCompletarTour(tour).catch(() => {})
    }, [])

    return (
        <TourContext.Provider value={{ toursVistos, listo, hasSeenTour, markTourSeen }}>
            {children}
        </TourContext.Provider>
    )
}

export const useTour = () => useContext(TourContext)
